__turbopack_context__.v({
  "excerpt": "Gm7PUq_excerpt",
  "partnerCard": "Gm7PUq_partnerCard",
  "partnerCardTile": "Gm7PUq_partnerCardTile",
  "partnerLogoWrapper": "Gm7PUq_partnerLogoWrapper",
  "partnerTagWrapper": "Gm7PUq_partnerTagWrapper",
  "partnerTitle": "Gm7PUq_partnerTitle",
  "solutionsPartner": "Gm7PUq_solutionsPartner",
  "text": "Gm7PUq_text",
});
